export enum DateRangeKey {
  THIS_WEEK = 'this-week',
  THIS_MONTH = 'this-month',
  THIS_YEAR = 'this-year',
  THIS_UK_TAX_YEAR = 'this-uk-tax-year',
  PAST_YEAR = 'past-year',
  PAST_SIX_MONTHS = 'past-six-months',
  PAST_QUARTER = 'past-quarter',
  PAST_MONTH = 'past-month',
  PAST_WEEK = 'past-week',
  PAST_UK_TAX_YEAR = 'past-uk-tax-year',
  ALL_TIME = 'all-time',
}
